import * as React from 'react';

import { RenderHtml } from '@blockworks/ui/legacy';

import { WordpressPage } from '@/utils/functions/wordpress/fetch-pages';

export const TokenTransparencyDescriptiveContent = ({ pageContent }: { pageContent: WordpressPage | null }) => {
    if (pageContent) {
        return (
            <RenderHtml
                rehypePlugins={[]}
                className="prose prose-purple max-w-none prose-headings:scroll-mt-28 pb-12 prose-headings:font-display prose-headings:font-normal lg:prose-headings:scroll-mt-[8.5rem] prose-lead:text-purple-500 prose-a:font-base prose-a:border-none prose-a:hover:border-none prose-a:underline prose-pre:rounded-xl prose-pre:bg-purple-900 prose-pre:shadow-lg"
                html={pageContent?.content?.rendered || ''}
            />
        );
    }

    return null;
};
